/**
 * Helpers shared across the Approvals page components.
 */
import type { ApprovalState } from "@/types/lighthouseApprovals";

export function stateChipClass(state: ApprovalState): string {
  switch (state) {
    case "pending":
      return "bg-warning-muted text-warning border-warning/30";
    case "info_requested":
      return "bg-info-muted text-info border-info/30";
    case "approved":
      return "bg-success-muted text-success border-success/30";
    case "denied":
      return "bg-destructive/10 text-destructive border-destructive/30";
    case "expired":
    default:
      return "bg-muted text-muted-foreground border-border";
  }
}

export function riskBarColor(score: number): string {
  if (score >= 71) return "bg-destructive";
  if (score >= 41) return "bg-warning";
  return "bg-success";
}

export function classificationClass(c?: string): string {
  switch (c) {
    case "confirmed":
      return "bg-success-muted text-success border-success/30";
    case "probable":
      return "bg-info-muted text-info border-info/30";
    case "possible":
      return "bg-warning-muted text-warning border-warning/30";
    case "not_agent":
      return "bg-destructive/10 text-destructive border-destructive/30";
    default:
      return "bg-muted text-muted-foreground border-border";
  }
}

export function shortAge(iso?: string): string {
  if (!iso) return "—";
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 0) return "now";
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  return `${d}d`;
}

export function ageIsStale(iso?: string): boolean {
  if (!iso) return false;
  return Date.now() - new Date(iso).getTime() > 24 * 3600 * 1000;
}
